import { Duration } from 'luxon';

export default function formatDuration(
  duration: number, // Seconds
  format: string = 'h:mm:ss',
) {
  return Duration.fromMillis(duration * 1000).toFormat(format);
}
